import {api, get} from '../../../config';

export default {
    read: function(data) {
        return {
            url: api('API_CREDIT_PERCENTS'),
            // url: '/static_api/calculation.json',
            type: 'get',
            responseType: 'json',
            data: {
                ...data,
                xref: get('XREF'),
            },
        };
    },
};
